import React from 'react';
import PropTypes from 'prop-types';
import StatusItem from '../StatusItem';

const propTypes = {
  status: PropTypes.string.isRequired,
  statusColor: PropTypes.string.isRequired
};

export default class BaseStatus extends React.Component {
  render() {
    return (
      <StatusItem
        status={this.props.status}
        statusColor={this.props.statusColor} />
    );
  }
}

StatusItem.propTypes = propTypes;
